<template>
  <v-container fluid>
    <v-data-table v-model="selected" :loading="loading ? '#0482fb' : null" :headers="headers" :items="statContrat"
      item-key="name">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des emissions</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch>
          <v-switch
            v-model="showYearFil"
            label="afficher les données de l'année "
            color="#0482fb"
            @change="showAllFillData"
            class="ml-10 pt-5"
          ></v-switch> -->
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche et importation vers excel ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date émission début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="periodStartDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date  émission fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="periodEndDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="fileName" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="Compagnie"></v-select>
                  </v-col>

                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>

                  <v-btn class="white--text pa-5" color="#1D6F42" :href="statFileEmission" target="_blank">
                    <v-icon size="30" class="mr-8" color="#fff" left>
                      mdi-microsoft-excel
                    </v-icon>
                    Exporter vers un tableau EXCEL
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { importDataExcel } from "../../exportDoc/index.js";
export default {
  name: "chartCall",
  data() {
    return {
      singleSelect: false,
      selected: [],
      loading: false,
      companyNameList: [],
      productNameList: [],
      headers: [
        {
          text: "N° client",
          align: "start",
          sortable: false,
          width: "90px",
          value: "customerNumber",
        },
        { text: "Nom / Raison sociale", width: "200px", value: "name" },
        { text: "compagnies", width: "200px", value: "company" },
        { text: "N° police / Avenant", width: "200px", value: "policeNumber" },
        { text: "Type d'opération", width: "200px", value: "actionType" },
        { text: "Branche", width: "200px", value: "product" },
        { text: "Catégorie", width: "200px", value: "category" },
        { text: "Date Effet", width: "200px", value: "effectDate" },
        { text: "Date échéance", width: "200px", value: "dueDate" },
        { text: "Date Enregistrement", width: "200px", value: "paymentDate" },
        { text: "Prime nette", width: "200px", value: "netPrime" },
        { text: "Prime totale", width: "200px", value: "totalPrime" },
        { text: "Commission", width: "200px", value: "commission" },
        { text: "Coût de police 100%", width: "200px", value: "accessory100" },
        { text: "Nom du commerciale", width: "200px", value: "agentName" },
        { text: "Observation", width: "200px", value: "observation" },
      ],
      workSheetColumnName: [
        "N° Client",
        "Nom / Raison sociale",
        "Compagnies",
        "N° police / Avenant",
        "Type d'opération",
        "Branche",
        "Catégorie",
        "Date effet",
        "Date échéance",
        "Date Enregistrement",
        "Prime nette",
        "Prime totale",
        "Commission",
        "Coût de police 100%",
        "Nom du commercial",
        "Observation",
      ],
      workSheetName: "Rapport Statistique d'emmission",
      nombre: "emission",
      users: [],
    };
  },
  mounted() {
    this.initStatContrat();
  },
  computed: {
    ...mapGetters(["statContrat", "Companies", "Products", "statFileEmission"]),
  },
  watch: {
    statCall() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
  },
  methods: {
    onEnter: function () {
      this.initStatContrat();
    },
    showAllFillData() {
      this.initStatContrat();
      //alert(this.showAllFil);
    },
    importData() {
      importDataExcel(
        this.workSheetColumnName,
        this.workSheetName,
        this.nombre,
        this.users
      );
    },
    ...mapActions(["getStateContrat", "getCompanies", "getProducts"]),
    async initStatContrat() {
      this.loading = true;
      try {
        await this.getStateContrat({
          fileName: this.fileName,
          product: this.product,
          company: this.company,
          periodStartDate: this.periodStartDate,
          periodEndDate: this.periodEndDate,
          withoutPeriod: this.showAllFil,
          currentYear: this.showYearFil,
        });
        this.users = this.statContrat;
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
  },
};
</script>
